const _getUrlParameter = (name: string) => {
  name = name.replace(/[[]/, "\\[").replace(/[\]]/, "\\]");
  const regex = new RegExp("[\\?&]" + name + "=([^&#]*)");
  const results = regex.exec(window.location.search);
  return results === null
    ? ""
    : decodeURIComponent(results[1].replace(/\+/g, " "));
};

export const getUrlParameter = (name: string) => {
  if (URLSearchParams) {
    const searchParams = new URLSearchParams(window.location.search);
    return searchParams.get(name);
  } else {
    return _getUrlParameter(name);
  }
};

export const getPersistingQueryStrings = () => {
  // Put all the persisting query strings here, just follow the pattern below.
  let qs = "";
  const redirect_url = getUrlParameter("redirect_url");
  if (!!redirect_url && redirect_url !== "") {
    qs = `?redirect_url=${redirect_url}`;
  }

  return qs;
};
